window['muted_mode'] = true;

// Lazy load all the videos
// Enable sound button for feature cards
['DOMContentLoaded', 'on:facet-filters:updated'].forEach(eventName => {
    document.addEventListener(eventName, function () {
        // Create an Intersection Observer to detect when the video is about to come into the viewport
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && entry.intersectionRatio > 0) {
                        const scriptTag = entry.target;
                        const videoElement = document.createElement('div');
                        videoElement.innerHTML = JSON.parse(scriptTag.textContent.trim());
                        scriptTag.parentNode.replaceChild(videoElement.firstChild, scriptTag);
                        observer.unobserve(scriptTag);
                    }
                });
            },
            {
                rootMargin: '500px 0px', // Load the video when it's within 500px of the viewport
                threshold: 0.01,
            }
        );

        // Observe all script tags with the type "video-template"
        document.querySelectorAll('script[type="video-template"]').forEach((scriptTag) => {
            observer.observe(scriptTag);
        });

        var featureCards = document.querySelectorAll('.feature-card');
        featureCards.forEach(function (card) {
            var soundBtn = card.querySelector('.sound-btn');
            if (soundBtn instanceof Node) {
                soundBtn.addEventListener('click', function (event) {
                    event.preventDefault();
                    // Toggle mute on current video
                    var videoElement = card.querySelector('video');
                    if (videoElement instanceof Node) {
                        if (videoElement.muted) {
                            // Mute all other videos except the current one
                            var allVideos = document.querySelectorAll('.product-video');
                            allVideos.forEach(function (video) {
                                // Change button text
                                var soundBtn = video.querySelector('.sound-btn');
                                soundBtn.innerHTML = '🔉 Sound';
                                // Mute
                                var vElem = video.querySelector('video');
                                if (vElem) {
                                    vElem.muted = true;
                                }
                            });

                            videoElement.muted = false;
                            soundBtn.innerHTML = '🔊 Mute';
                            window['muted_mode'] = false;
                        } else {
                            // Mute all other videos except the current one
                            var allVideos = document.querySelectorAll('.product-video');
                            allVideos.forEach(function (video) {
                                // Change button text
                                var soundBtn = video.querySelector('.sound-btn');
                                soundBtn.innerHTML = '🔉 Sound';
                                // Mute
                                var vElem = video.querySelector('video');
                                if (vElem) {
                                    vElem.muted = true;
                                }
                            });

                            videoElement.muted = true;
                            soundBtn.innerHTML = '🔉 Sound';
                            window['muted_mode'] = true;
                        }
                    } else {
                        console.error('videoElement is not a valid DOM element.');
                    }
                });
            } else {
                console.error('soundBtn is not a valid DOM element.');
            }
        });

        // Handle video button clicks
        var videoBtns = document.querySelectorAll('.video-btn');
        videoBtns.forEach(function (btn) {
            btn.addEventListener('click', function (event) {
                event.preventDefault();
                var productId = btn.getAttribute('data-product-id');
                var videoHTML = JSON.parse(btn.querySelector('script[type="template"]').innerHTML.trim());
                var productCard = document.querySelector('product-card[data-product-id="' + productId + '"]');
                var alt = btn.getAttribute('data-alt');

                // Get first link
                var productLink = productCard.querySelector('a');

                // Convert videoHTML string to DOM element
                var tempDiv = document.createElement('div');
                tempDiv.classList.add('product-video');
                // If alt contains [PROMO]
                if (alt.indexOf('[PROMO]') > -1) {
                    tempDiv.classList.add('generated-promo');
                }
                tempDiv.innerHTML =
                    '<a href=' + productLink.getAttribute('href') + '>' + videoHTML + '</a><div class="sound-btn">🔉 Sound</div>';

                // Get the parent of the productCard and add class
                var productCardParent = productCard.parentNode;
                productCardParent.classList.add('mobile-expanded-card');

                // Check if videoElement and productCard are valid DOM elements
                if (productCard instanceof Node) {
                    // Remove any .product-video elements
                    var productVideos = productCard.querySelectorAll('.product-video');
                    productVideos.forEach(function (video) {
                        video.remove();
                    });
                    // Appending video to product card
                    productCard.appendChild(tempDiv);
                    productCard.classList.add('video-active');

                    // If the window is not in muted mode, then unmute the video
                    if (!window['muted_mode']) {
                        var videoElement = productCard.querySelector('video');
                        if (videoElement instanceof Node) {
                            // Mute all other videos
                            var allVideos = document.querySelectorAll('.product-video');
                            allVideos.forEach(function (video) {
                                var vElem = video.querySelector('video');
                                if (!vElem) return;
                                // Change button text
                                var soundBtn = video.querySelector('.sound-btn');
                                soundBtn.innerHTML = '🔉 Sound';
                                // Mute
                                vElem.muted = true;
                            });

                            videoElement.muted = false;

                            // Update button text
                            var soundBtn = productCard.querySelector('.sound-btn');
                            soundBtn.innerHTML = '🔊 Mute';
                        } else {
                            console.error('videoElement is not a valid DOM element.');
                        }
                    }

                    // On mobile, scroll to id
                    if (window.innerWidth < 768) {
                        var videoElement = productCard.querySelector('video');
                        if (videoElement instanceof Node) {
                            videoElement.scrollIntoView({ behavior: 'smooth' });
                        }
                    }

                    // Enable the sound button .sound-btn
                    var soundBtn = productCard.querySelector('.sound-btn');
                    soundBtn.addEventListener('click', function (event) {
                        event.preventDefault();
                        // Toggle mute on current video
                        var videoElement = productCard.querySelector('video');
                        if (videoElement instanceof Node) {
                            if (videoElement.muted) {
                                // Mute all other videos except the current one
                                var allVideos = document.querySelectorAll('.product-video');
                                allVideos.forEach(function (video) {
                                    var vElem = video.querySelector('video');
                                    if (!vElem) return;
                                    // Change button text
                                    var soundBtn = video.querySelector('.sound-btn');
                                    soundBtn.innerHTML = '🔉 Sound';
                                    // Mute
                                    vElem.muted = true;
                                });

                                videoElement.muted = false;
                                soundBtn.innerHTML = '🔊 Mute';
                                window['muted_mode'] = false;
                            } else {
                                // Mute all other videos except the current one
                                var allVideos = document.querySelectorAll('.product-video');
                                allVideos.forEach(function (video) {
                                    var vElem = video.querySelector('video');
                                    if (!vElem) return;
                                    // Change button text
                                    var soundBtn = video.querySelector('.sound-btn');
                                    soundBtn.innerHTML = '🔉 Sound';
                                    // Mute
                                    vElem.muted = true;
                                });

                                videoElement.muted = true;
                                soundBtn.innerHTML = '🔉 Sound';
                                window['muted_mode'] = true;
                            }
                        } else {
                            console.error('videoElement is not a valid DOM element.');
                        }
                    });
                } else {
                    console.error('Either videoElement or productCard is not a valid DOM element.');
                }
            });
        });
    });
});

/* Set classes */
function updateGrid() {
    var true_index = 0;
    const listItems = document.querySelectorAll('.main-products-grid__results li');
    listItems.forEach((item, index) => {
        // Remove the 'preceding-feature' class from all items initially
        item.classList.remove('preceding-feature');
        // Check if the item is not the last item and the next item is a feature card
        true_index++;

        // If this has class .feature-card add
        if (item.classList.contains('feature-card')) {
            true_index++;
        }

        if (true_index % 2) {
            item.classList.add('odd');
        }

        if (index < listItems.length - 1 && listItems[index + 1].classList.contains('feature-card') && true_index % 2) {
            item.classList.add('preceding-feature');
            true_index++;
        }
    });
}

// Call updateGrid on DOM load and window resize
window.addEventListener('DOMContentLoaded', updateGrid);
window.addEventListener('resize', updateGrid);

/* Handle mobile video feed */
document.addEventListener('DOMContentLoaded', function () {
    // Only execute on mobile
    if (window.innerWidth < 769) {
        var videos = document.querySelectorAll('video');
        var observerOptions = {
            root: null, // Document viewport
            threshold: 0.5, // Trigger callback when 50% of the video is in the viewport
        };

        var observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // Play the video that's in the viewport
                    const playPromise = entry.target.play();
                    if (playPromise !== undefined) {
                        playPromise.catch((error) => {
                            if (error.name !== 'AbortError') console.warn(error);
                        });
                    }

                    // Check if window.muted_mode is false, then unmute the video
                    if (!window['muted_mode']) {
                        entry.target.muted = false;

                        // Handle changing text on sound button
                        var soundBtn = entry.target.parentNode.querySelector('.sound-btn');
                        soundBtn.innerHTML = '🔊 Mute';

                        // Mute all other videos
                        videos.forEach(function (video) {
                            if (video !== entry.target) {
                                // Change button text
                                var soundBtn = video.parentNode.querySelector('.sound-btn');
                                soundBtn.innerHTML = '🔉 Sound';
                                // Mute
                                video.muted = true;
                            }
                        });
                    }

                    // Pause other videos
                    videos.forEach(function (video) {
                        if (video !== entry.target) {
                            video.pause();
                        }
                    });
                }
            });
        }, observerOptions);

        // Observe each video
        videos.forEach(function (video) {
            observer.observe(video);
        });
    }
});